import { useState } from "react";

const AlertButton = ({ href = "/bot", label = "کلیک کنید" }) => {
  const [hover, setHover] = useState(false);

  const buttonStyle = {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "10px 15px",
    color: "white",
    fontWeight: "900",
    borderRadius: "9999px",
    fontSize: "12px",
    background:
      "linear-gradient(90deg, rgb(43, 76, 149), rgb(53, 152, 210), rgb(108, 204, 242))",
    boxShadow: hover
      ? "0 8px 25px rgb(43, 76, 149)"
      : "0 4px 12px rgba(0,0,0,0.3)",
    transform: hover ? "scale(1.05)" : "scale(1)",
    transition: "all 0.3s ease-in-out",
    overflow: "hidden",
    textDecoration: "none",
    width: "fit-content",
  };

  const shimmerStyle = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
    transform: "translateX(-100%)",
    animation: "shimmer 2s infinite",
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={buttonStyle}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <span style={{ position: "relative", zIndex: 1 }}>{label}</span>
      <span style={shimmerStyle} />
      <style>
        {`
          @keyframes shimmer {
            100% { transform: translateX(100%); }
          }
        `}
      </style>
    </a>
  );
};

export default AlertButton;
